import React from 'react'
import { Outlet, useLocation, useParams } from 'react-router-dom'
import { EventProvider } from 'context/EventContext'
import { BottomNav, SideRail } from 'shared/components/layout/Nav'
import TopBar from 'shared/components/layout/TopBar'
import { cn } from 'shared/util/cn'

function EventLayout() {
  const { eventId } = useParams()
  const location = useLocation()
  const hideChrome = /\/(scan|result)$/.test(location.pathname)

  return (
    <EventProvider eventId={eventId}>
      <div className="flex min-h-dvh bg-bg text-ink">
        {!hideChrome && <SideRail />}
        <div className="flex min-w-0 flex-1 flex-col">
          {!hideChrome && <TopBar />}
          <main className={cn('flex-1', !hideChrome && 'safe-bottom lg:pb-8')}>
            <Outlet />
          </main>
          {!hideChrome && <BottomNav />}
        </div>
      </div>
    </EventProvider>
  )
}

export default EventLayout
